import React, { useState, useEffect } from 'react'
import { Fade } from 'react-reveal'
import { pseudoRandom } from '../utils'

type VideoType = { url: string }

export type HeroCinematicProps = {
  image: {
    url: string
    alt: string
  }
  headline: { text: string }
  text: { html: string }
  videos: VideoType[]
  renderAdditionalComponent?: () => JSX.Element
}

const HeroCinematic = ({ videos, headline, text, renderAdditionalComponent }: HeroCinematicProps) => {
  const [loaded, setLoaded] = useState(false)

  const [currVideo, setCurrVideo] = useState(0)
  const [shuffledVideos, setShuffledVideos] = useState<VideoType[]>(videos)

  useEffect(() => {
    setShuffledVideos(pseudoRandom(videos, (a, b) => (a.url && b.url ? b.url.length - a.url.length : 0)))
    setLoaded(true)
  }, [])

  const sharedFadeOpts = {
    when: loaded,
    duration: 500
  }

  if (shuffledVideos.length === 0) return null

  const updateSrc = () => {
    // This way videos will loop based on total number of videos
    setCurrVideo((currVideo + 1) % videos.length)
  }

  return (
    <div className='hero-cinematic position-relative w-100 page-slice-spacer'>
      <div className='hero-cinematic__video position-relative h-100 w-100 overflow-hidden'>
        <video
          className='h-100 w-100'
          autoPlay
          muted
          loop={shuffledVideos.length === 1}
          playsInline
          onEnded={() => updateSrc()}
          src={shuffledVideos[currVideo].url}
        />
        <span className='hero-cinematic__overlay d-none d-lg-block' />

        <div className='hero-cinematic__content container d-lg-flex flex-column justify-content-center h-100 pt-2 pt-lg-0'>
          <Fade {...sharedFadeOpts} up distance='10px' delay={250}>
            <h1>{headline.text}</h1>
          </Fade>
          <Fade {...sharedFadeOpts} up distance='10px' delay={500}>
            <div className='article parag--lg' dangerouslySetInnerHTML={{ __html: text.html }} />
          </Fade>
        </div>

        <Fade {...sharedFadeOpts} up distance='10px' delay={1250}>
          <div className='hero-cinematic__additional-component w-100 d-none d-lg-block'>
            <div className='container'>{renderAdditionalComponent && renderAdditionalComponent()}</div>
          </div>
        </Fade>
      </div>
    </div>
  )
}

export default HeroCinematic
